// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1UakT","left":"InfoRow_left__XJqpz"};